<template>
    <div>
        <div class="card shadow">

            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.prenatalConsultations', 1) }} - {{ $tc('message.complementaryExams', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-complementary-examination',params:{ consultation:consultation_id} }">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            class="mb-3"
                            aria-controls="complementarys-table"
                    ></b-pagination>

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mComplementaries"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="complementarys-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mComplementaries"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row">
                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.id" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.id"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.complementaryExams', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.reference }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deletecomplementaryExam(data.item.id)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.id)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="complementarys-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    export default {
        name: "ComplementaryExamsPerPrenatalConsultation",
        computed: {
            ...mapGetters(["prenatalConsultation","prenatalConsultComplementarieExams"]),

            mComplementaries: function() {
                let eArray = [];

                _.forEach(this.prenatalConsultation.examens_complementaire, function(exam) {
                    let e = {};

                    e.reference = exam.reference;
                    if(exam.description){
                        e.description = exam.description.length > 20 ? exam.description.substr(0, 20) + '...' : exam.description;
                    }else{
                        e.description = ''
                    }
                    e.date = moment(exam.created_at).format('DD-MM-YYYY HH:mm');
                    e.id = exam.id;
                    e.slug = exam.slug;

                    eArray.push(e);
                });

                return eArray;
            },

            rows: function() {
                return this.mComplementaries.length;
            }
        },
        data() {
            return {
                consultation_id: this.$route.params.consultation,
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'reference',
                        label: this.$i18n.tc('message.references', 1),
                    },
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },
        methods: {
            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getPrenatalConsultation", { args });
            },

            formattedDisplay (result) {
                return result.reference;
            },

            itemSelected(item) {
                this.$router.push({ name: 'complementary-exam', params: { complementary: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'complementary-exam', params: { complementary: items[0].slug } });
            },

            deletecomplementaryExam(complementary) {
                let self = this;
                let examensComplementaire= [];
                examensComplementaire.push(complementary);
                let args = {
                    examensComplementaire :examensComplementaire,
                    consultation: this.prenatalConsultation.id,
                };

                let successMessage = this.$i18n.t('message.complementaryExamRemoved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePrenatalConsultationComplementarieExam', { args, index: complementary, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + complementary);
                    });
            }
        },
        mounted() {
            this.getConsultation();

        }
    }
</script>

<style scoped>

</style>